import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;
  padding-left: 250px;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #000;
  border: 1px solid rgba(34, 36, 38, 0.15);
  padding: 10px 20px;
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

export const Field = styled.div`
  padding: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p{
    margin: 0;
    font-weight: 600;
    font-size: 16px;
  }

  span{
    width: 100%;
    height: 35px;
    margin: 0;
    padding: 0.5rem;
    color: rgba(0, 0, 0, 0.87);
    font-size: 16px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 4px;
  }
`;

export const Link = styled.a`
  margin-top: ${({ margin }) => margin || '0px'};
  ${({ color }) => !!color && `background-color: ${color};`}
  padding: 7px;
  border-radius: 4px;
  color: ${({ color }) => !color ? '#000' : '#fff'};
  cursor: pointer;
  display: flex;
  align-items: center;
  max-width: 300px;
  ${({ color }) => !color && ` border: 1px solid #000;`}

  svg {
    margin-right: 5px;
  }
`;

export const UserData = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  div{
    width: 100%;
  }
`;

export const SubscriberContainer = styled.div`
  margin-top: 10px;
  width: 100%;
`;

export const Button = styled.button`
  cursor: pointer;
  background-color: #d3d3d3;
  border: 1px solid #000;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 500;
`;

